import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
}

const roles = {
    state: {},
    mutations: {},
    actions: {
        // GET

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}


export default roles
